import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9f2961ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9f2961ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2961ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f2961ac')) {
      api.createRecord('9f2961ac', component.options)
    } else {
      api.reload('9f2961ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9f2961ac&scoped=true", function () {
      api.rerender('9f2961ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/storeBrand/index.vue"
export default component.exports